// Impersonation (spec 2026-10-04-03): the session a platform admin opens as a
// contact carries an `impersonated_by` claim in its access token. The front
// reads it only to show the banner; nothing is restricted on it.

export interface AccessTokenClaims {
    user_uid?: string
    org_code?: string
    impersonated_by?: string
}

/** decodeAccessToken reads a JWT payload without verifying it (display only). */
export function decodeAccessToken(token: string | null | undefined): AccessTokenClaims | null {
    if (!token) return null
    const parts = token.split('.')
    if (parts.length !== 3) return null
    try {
        const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
        const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4)
        const json = new TextDecoder().decode(Uint8Array.from(atob(padded), (c) => c.charCodeAt(0)))
        const claims = JSON.parse(json)
        return claims && typeof claims === 'object' ? (claims as AccessTokenClaims) : null
    } catch {
        return null
    }
}

/** impersonatedBy returns the admin uid of an impersonated session, or null. */
export function impersonatedBy(token: string | null | undefined): string | null {
    return decodeAccessToken(token)?.impersonated_by || null
}

/** The token of an impersonation URL: its last path segment. */
export function impersonationTokenFromUrl(url: string): string {
    return url.split('/impersonate/')[1] ?? ''
}
